import React from "react";
import { Box } from "@mui/material";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import TpUsersByType from "./TpUsersByType";
import TechPrepStaffBreadCrumbs from "../Layout/TechPrepStaffBreadCrumbs";
import TpUserMgtBreadCrumbs from "../Layout/TpUserMgtBreadCrumbs";

const TpStaff = () => {
  return (
    <Box sx={{ paddingTop: "80px" }}>
      {" "}
      {/* Add top padding to avoid header overlap */}
      <TpUserMgtBreadCrumbs />
      <TechPrepStaffBreadCrumbs pageName="Staff Management" />
      <TpUsersByType
        userType="staff"
        title="Tech Prep Staff"
        icon={faUsers}
        iconColor="#ff9800"
      />
    </Box>
  );
};

export default TpStaff;
